import React, { Component } from 'react';
import { TextField, InputAdornment, IconButton, FormLabel } from '@mui/material';
import EventIcon from '@mui/icons-material/Event';
import { MobileDateTimePicker } from '@mui/x-date-pickers';

class DateRangeFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            from_date: this.props.from_date,
            to_date: this.props.to_date,
            pickerOpened: false
        };
    }

    render() {
        return (
            <>
                <FormLabel style={{ marginBottom: '10px', marginLeft: '10px' }}>
                    Date Range {this.props.dateType === 'received' ? '(Received date)' : this.props.dateType === 'collected' ? '(Collected date)' : ''}
                </FormLabel>
                <div className={'dateRangeBar mb-2 ' + (this.props.type === 'dashboard' ? 'mb-3' : '')}>
                    <button
                        className={
                            'btn btn-info dateRangeBtn mx-1 mb-2' + (this.props.date_range === 'today' ? ' active' : '')
                        }
                        onClick={() => this.props.updateDateRange('today')}
                    >
                        Today
                    </button>
                    <button
                        className={
                            'btn btn-info dateRangeBtn mx-1 mb-2' + (this.props.date_range === 'week' ? ' active' : '')
                        }
                        onClick={() => this.props.updateDateRange('week')}
                    >
                        Week
                    </button>
                    <button
                        className={
                            'btn btn-info dateRangeBtn mx-1 mb-2' + (this.props.date_range === 'month' ? ' active' : '')
                        }
                        onClick={() => this.props.updateDateRange('month')}
                    >
                        Month
                    </button>
                    <button
                        className={
                            'btn btn-info dateRangeBtn mx-1 mb-2' +
                            (this.props.date_range === 'quarter' ? ' active' : '')
                        }
                        onClick={() => this.props.updateDateRange('quarter')}
                    >
                        Quarter
                    </button>
                </div>
                <div className="dateRangeBar dateRangeBarPickers">
                    <MobileDateTimePicker
                        value={this.state.pickerOpened ? this.state.from_date : this.props.from_date}
                        onChange={(dateTime) => this.setState({ from_date: dateTime })}
                        onOpen={() => this.setState({ from_date: this.props.from_date, pickerOpened: true })}
                        onClose={() => this.setState({ pickerOpened: false })}
                        onAccept={(dateTime) => this.props.handleDateFiltersChange(dateTime.$d, 'from_date')}
                        label="From Date"
                        renderInput={(props) => (
                            <TextField
                                {...props}
                                className="ml-1 mr-2 mt-2"
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton edge="end">
                                                <EventIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                            />
                        )}
                    />
                    <MobileDateTimePicker
                        value={this.state.pickerOpened ? this.state.to_date : this.props.to_date}
                        onChange={(dateTime) => this.setState({ to_date: dateTime })}
                        onOpen={() => this.setState({ to_date: this.props.to_date, pickerOpened: true })}
                        onClose={() => this.setState({ pickerOpened: false })}
                        onAccept={(dateTime) => this.props.handleDateFiltersChange(dateTime.$d, 'to_date')}
                        label="To Date"
                        renderInput={(props) => (
                            <TextField
                                {...props}
                                className="mt-2"
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton edge="end">
                                                <EventIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                            />
                        )}
                    />
                </div>
            </>
        );
    }
}

export default DateRangeFilter;
